import { TextInput } from "@certa/catalyst/components/Inputs";
import { useFilterOverlay } from "../FilterOverlay/FilterOverlayContext";

const TextFilter = () => {
  const { handleSearch, label, searchValue, setSearchValue } =
    useFilterOverlay();

  return (
    <TextInput
      label={label}
      value={searchValue}
      onChange={value => setSearchValue(value)}
      onKeyDown={e => {
        if (e.key === "Enter") {
          handleSearch();
        }
      }}
      placeholder={`Search By ${label}...`}
    />
  );
};

export { TextFilter };
